<ion-text>
  <h3 class="participating-stores-title">{{ node?.title }}</h3>
</ion-text>

<ion-grid class="ion-justify-content-start ion-no-padding">
  <ion-row [style.columnCount]="columnCount">
    <ion-col *ngFor="let item of node?.items">
      <ng-container *ngIf="item?.value; else storeName">
        <a [routerLink]="'/shop/' + item.value">{{ item.text }}</a>
      </ng-container>
      <ng-template #storeName>
        {{ item }}
      </ng-template>
    </ion-col>
  </ion-row>
</ion-grid>
